import { NB } from '@cerebral-inc/ui';
import { segmentIntegrations } from '../shared/analytics/segment';
import { ADHD_ASSESSMENT_RESULT_GET_STARTED_BUTTON } from '../shared/analytics/segment-events';

const { Flex, Box, Center, Text, Button } = NB;

interface TextButtonRightProps {
  title: string;
  description: string;
}

const TextButtonRight = ({ title, description }: TextButtonRightProps) => {
  const handleContinue = () => {
    window.analytics?.track(
      ADHD_ASSESSMENT_RESULT_GET_STARTED_BUTTON,
      { title },
      segmentIntegrations
    );
    window.open(`${process.env.REACT_APP_CLIENT_APP_URL}`, '_self');
  };

  return (
    <Flex alignItems="center" pt={{ base: '64px', sm: '96px' }} pb="64px">
      <Center>
        <Box maxW={{ base: '100%', lg: '1264px' }} px="24px">
          <Flex
            flexDir={{ base: 'column', lg: 'row' }}
            alignItems="center"
            justifyContent="space-between"
          >
            <Box w={{ base: '100%', lg: 'calc(100% - 208px - 20vw)' }}>
              <Text
                fontFamily="Poppins"
                fontSize="14px"
                fontWeight={500}
                lineHeight="24px"
                color="#353A41"
              >
                Next steps
              </Text>
              <Text
                fontFamily="Poppins"
                fontSize={{ base: '24px', sm: '28px' }}
                fontWeight={600}
                lineHeight={{ base: '28px', sm: '32px' }}
                color="#1C1E21"
                mt="20px"
              >
                {title}
              </Text>
              <Text
                mt="20px"
                fontSize="16px"
                lineHeight="24px"
                color="rgba(53, 58, 65, 1)"
                fontFamily="Poppins"
              >
                {description}
              </Text>
            </Box>
            <Button
              w={{ base: '100%', md: '320px' }}
              h="56px"
              _text={{
                fontFamily: 'Poppins',
                fontSize: '14px',
                fontWeight: 600
              }}
              mt={{ base: '32px', lg: 0 }}
              onPress={handleContinue}
            >
              Continue
            </Button>
          </Flex>
        </Box>
      </Center>
    </Flex>
  );
};

export default TextButtonRight;
